// extracted by mini-css-extract-plugin
export var chatHtmlText = "_o0-2";
export var chatLink = "_o0-0";
export var chatText = "_o0-1";